import { Store } from '@reduxjs/toolkit';
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';

import { StoreSubscribeListener } from '../types';
import { createLinkedList } from '../utils';

// Все подписки из useSelector хуков хранятся в связном списке, чтобы иметь O(1) при отписке.
export function createListenerCollection() {
    const list = createLinkedList<StoreSubscribeListener>();

    return {
        notify() {
            batchedUpdates(() => {
                let listener = list.head();

                while (listener) {
                    // Записываем следующего слушателя перед вызовом текущего,
                    // так как текущий может отписаться и listener.next станет null
                    let nextListener = listener.next;

                    listener.value();

                    listener = nextListener;
                }
            });
        },

        subscribe(callback: StoreSubscribeListener) {
            const listener = list.append(callback);

            return function unsubscribe() {
                list.remove(listener);
            };
        },
    };
}

/**
 * Создает функцию подписки на изменения стора, которая автоматически батчит изменения во всех селекторах.
 *
 * @param store – Модульный стор.
 * @returns Функция подписки, которая автоматически батчит изменения во всех селекторах.
 */
export function createBatchedSubscription(store: Store) {
    const listeners = createListenerCollection();

    store.subscribe(listeners.notify);

    return function addSubscription(listener: StoreSubscribeListener) {
        return listeners.subscribe(listener);
    };
}
